module.exports = __webpack_public_path__ + "static/media/Profile-dark.6d80502e.svg";